// @mui
import { Typography, Stack } from '@mui/material';
// components
import Logo from '../../components/logo';
import Image from '../../components/image';
//
import { StyledRoot, StyledSectionBg, StyledSection, StyledContent } from './styles';
import LogoWide from '../../components/logoWide/LogoWide';
import { useTheme } from '@mui/material/styles';

// ----------------------------------------------------------------------

type Props = {
  title?: string;
  illustration?: string;
  children: React.ReactNode;
};

export default function LoginLayout({ children, illustration, title }: Props) {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <StyledRoot>
      <StyledSection>
        <LogoWide sx={{ mt: 2 }} />

        <Stack sx={{ width: '100%', maxWidth: '430px' }}> {children} </Stack>
        <StyledSectionBg />
      </StyledSection>
    </StyledRoot>
  );
}
